import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import { Pagination } from 'antd';
import style from './PaginationComponent.module.scss';

const PaginationComponent: React.FC = () => {
	const { changeCurrentPage, gamesForAssign, currentPage, countOfItems } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = gamesForAssign.gamesCount;

	return (
		<div className={style.container} data-test="PaginationComponent">
			<Text
				className={style.counter}
				translationNameSpace="listing"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={gamesForAssign.gamesCount}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};

export default PaginationComponent;
